import { MapPin, Clock } from "lucide-react";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { Reveal, Eyebrow } from "./shared";

const GUESTS = [
  "Business Leaders",
  "Entrepreneurs",
  "Philanthropists",
  "Creatives",
  "Families",
  "Corporate Teams",
  "Fashion Lovers",
  "Community Leaders",
  "Influencers",
  "Educators",
  "Healthcare Professionals",
  "Adoption & Foster-Care Advocates",
];

const Chicago = () => {
  const { event, images } = EVENT_CONFIG;

  return (
    <section id="chicago" data-testid="chicago-section" className="relative py-28 sm:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{ backgroundImage: `url(${images.chicago})` }}
      />
      <div className="absolute inset-0 bg-ink/82" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-transparent to-ink" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="flex flex-col gap-7 items-start">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="font-serif italic text-3xl sm:text-4xl gold-text leading-none">05</span>
              <span className="h-px w-10 sm:w-16 bg-champagne/40" />
              <Eyebrow>The Chicago Moment</Eyebrow>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ivory leading-[1.05]">
              CHICAGO,
              <br />
              <span className="gold-shimmer">THIS ONE IS FOR YOU.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-cream text-base sm:text-lg leading-relaxed max-w-xl">
              One night. One city. The most stylish philanthropic evening of the fall — where Chicago's
              leaders, creatives and families trade an ordinary Saturday for a crown-worthy cause.
            </p>
          </Reveal>
          <Reveal delay={0.24} className="flex flex-wrap gap-2.5">
            {GUESTS.map((g) => (
              <span
                key={g}
                className="px-3.5 py-1.5 rounded-full border border-champagne/25 text-champagne/90 text-[10px] sm:text-[11px] uppercase tracking-[0.16em]"
              >
                {g}
              </span>
            ))}
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div data-testid="chicago-venue-card" className="glass gold-stroke rounded-3xl p-8 sm:p-10 grain">
            <p className="text-[10px] uppercase tracking-[0.35em] text-gold">The Venue</p>
            <h3 className="font-serif text-2xl sm:text-3xl text-ivory mt-3">{event.venue}</h3>
            <p className="mt-2 text-cream/80 text-sm flex items-center gap-2">
              <MapPin size={14} className="text-gold shrink-0" /> {event.venueAddress}
            </p>
            <div className="mt-6 space-y-3 border-t border-champagne/15 pt-6">
              <p className="flex items-center gap-3 text-sm text-cream">
                <Clock size={14} className="text-gold shrink-0" />
                VIP Reception · {event.vipTime}
              </p>
              <p className="flex items-center gap-3 text-sm text-cream">
                <Clock size={14} className="text-gold shrink-0" />
                Gala · {event.galaTime}
              </p>
            </div>
            <p className="mt-6 text-xs text-cream/50 leading-relaxed">
              A historic Oak Park landmark — crystal, candlelight and a room built for a night like this.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Chicago;
